// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

const productCategoriesServiceUrl = "/api/cmi/categories";

export interface ProductCategoriesPayload extends ApiParameter {
    categories: string[];
    expand?: string[];
}

export async function getProductCategoriesData(data: ProductCategoriesPayload): Promise<CategoryModel[]> {
    const categories = await get<CategoryModel[]>(
        `${productCategoriesServiceUrl}?categories=${data.categories.filter(category => category !== "").toString()}`,
        { expand: data.expand } as ApiParameter,
    );
    return categories;
}
